export const hamburgerAnimate = () => {
    const navToggler = document.querySelector('.nav-toggler')
    const hamburgerMenu = document.querySelector('.hamburger-menu')
    const navbar = document.querySelector('.navbar')
    const navClose = document.querySelector('.nav-close')

    navClose.addEventListener('click', () => {
        document.querySelector('body').classList.remove('block')
        navbar.classList.remove('active')
        hamburgerMenu.classList.remove('animate')
    })

    navToggler.addEventListener('click', () => {
        document.querySelector('body').classList.add('block')
        navbar.classList.add('active')
        hamburgerMenu.classList.add('animate')
    })
}

// call menu with list of items

export const openObjectsMenu = () => {
    const callObjectsMenus = document.querySelectorAll('.callObjectsMenu');
    const objectsMenus = document.querySelectorAll('.objectsMenu');

    callObjectsMenus.forEach((callObjectsMenu, index) => {
        const objectsMenu = objectsMenus[index];

        if (objectsMenu) {
            callObjectsMenu.addEventListener('click', () => {
                objectsMenu.classList.toggle('scale-y-0');
            });
        }
    });
}

